var map = {
	"./accentpay.svg": "19a9",
	"./asia_swift.svg": "b4f9",
	"./axcess.svg": "a1ca",
	"./b2binpay-otm.svg": "28dc",
	"./b2binpay.svg": "3a29",
	"./bank.svg": "55e6",
	"./coingate.svg": "4262",
	"./cupgeneric.svg": "794c",
	"./ecommpay.svg": "f130",
	"./fasapay.svg": "6eb0",
	"./fasapay_static.svg": "8409",
	"./fxpaygate.svg": "d33e",
	"./gatetopay-otm.svg": "3862",
	"./gatetopay.svg": "8208",
	"./gpaysafe.svg": "f483",
	"./iaccount.svg": "8acb",
	"./icm-praxis.svg": "d05f",
	"./icmcup-icmtrader.svg": "4c09",
	"./icmcup-old.svg": "b11b",
	"./icmcup.svg": "2d31",
	"./ingenico.svg": "db10",
	"./ipay-2.svg": "b17e",
	"./ipay.svg": "9cbd",
	"./ipayment.svg": "b06c",
	"./isignthis.svg": "94b7",
	"./isxpay.svg": "0930",
	"./knet-kwt.svg": "55f4",
	"./lionpayment.svg": "5524",
	"./mastercard.svg": "0ec7",
	"./mygate.svg": "b994",
	"./neteller.svg": "8517",
	"./neteller_static.svg": "9226",
	"./noirepay.svg": "c5d5",
	"./noirepayskrill.svg": "edd2",
	"./okpay.svg": "f448",
	"./orangepay.svg": "2868",
	"./orbpay.svg": "e44a",
	"./paymentasia.svg": "580a",
	"./paypal-button-icon.svg": "b483",
	"./paypal-button-text.svg": "d236",
	"./paypal.svg": "14aa",
	"./paysec.svg": "9f76",
	"./paysec_BANK_TRANSFER.svg": "7ef2",
	"./paysec_QQPAY.svg": "344f",
	"./paysec_WECHAT.svg": "9218",
	"./payza.svg": "cb85",
	"./perfectmoney.svg": "a8b9",
	"./perfectmoney_static.svg": "6882",
	"./polipay.svg": "1d08",
	"./praxispay.svg": "da09",
	"./qubepay.svg": "37c6",
	"./rpn.svg": "bc20",
	"./s4ucash.svg": "3ecd",
	"./safecharge-zcom.svg": "e35f",
	"./safecharge.svg": "f7d2",
	"./securetrading.svg": "263a",
	"./sepa.svg": "7889",
	"./sheepy.svg": "4a7bc",
	"./skrill.svg": "256c",
	"./skrill_static.svg": "b360",
	"./solidpayments.svg": "310c",
	"./solidpayments2.svg": "988f",
	"./sorexpay.svg": "a20a",
	"./submit.svg": "3dda",
	"./tffchinaunion.svg": "7f9f",
	"./trustpay.svg": "7f85",
	"./visa.svg": "28de",
	"./voguepay_static.svg": "f707",
	"./worldpay.svg": "7e6d",
	"./worldpay_old.svg": "28e5",
	"./zotapay.svg": "b006"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc3e";